<template>
    <div>
        <div class="families">
            <div class="label left">Classification by</div>
            <div class="tabs is-boxed is-large">
                <ul>
                    <li>
                        <a id="pfam" @click="changeType('pfam')">
                            <span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
                            <span>Pfam</span>
                        </a>
                    </li>
                    <li>
                        <a id="chembl"  @click="changeType('chembl')">
                            <span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
                            <span>ChEMBL</span>
                        </a>
                    </li>
                    <li>
                        <a id="cdhit"  @click="changeType('cdhit')">
                            <span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
                            <span>CD-HIT</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <div class="tab_content" v-if="type=='pfam'">
                    <div class="columns" v-if="families.length > 0">
                        <div class="column is-one-quarter">Clan</div>
                        <div class="column is-three-quarters">
                            <v-select :options="families[0]" @input="(val) => changeFamily(1, val)" @click="changeFamily"></v-select>
                        </div>
                    </div>
                    <div class="columns" v-if="families.length > 1">
                        <div class="column is-one-quarter">Family</div>
                        <div class="column is-three-quarters">
                            <v-select :options="families[1]" @input="(val) => changeFamily(2, val)" @click="changeFamily"></v-select>
                        </div>
                    </div>
                </div>
                <div class="tab_content" v-show="type=='chembl'">
                    <div v-for="n of 6" :key="'chembl' + n">
                        <div class="columns" v-if="families.length > (n - 1)">
                            <div class="column is-one-quarter">Layer {{ n }}</div>
                            <div class="column is-three-quarters">
                                <v-select :options="families[n - 1]" @input="(val) => changeFamily(n, val)" @click="changeFamily"></v-select>
                            </div>
                        </div>
                    </div>
               </div>
                <div class="tab_content"  v-show="type=='cdhit'">
                    <div class="columns">
                        <div class="column is-one-quarter">UniProt Accession No</div>
                        <div class="column is-three-quarters"><input class="input" type="text" v-model="accession"></div>
                    </div>
                    <div class="columns">
                        <div class="column is-one-quarter">Similarity</div>
                        <div class="column is-three-quarters">
                            <select class="input" v-model="similarity">
                                <option value="90">90%</option>
                                <option value="50">50%</option>
                                <option value="40">40%</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div>
                <button @click="addTargets">Add</button>
            </div>
            <div>
                <button @click="clearTargets">Clear</button>
            </div>
        </div>
        <div class="columns is-multiline targets">
            <div class="column is-2" v-for="target in targets" :key="target">
                <TargetItem :name="target" @delete="deleteTarget"></TargetItem>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import "vue-select/src/scss/vue-select.scss";
import TargetItem from "@/components/TargetItem";

export default {
    name: 'TargetSelector',
    components: {
        TargetItem,
        vSelect,
    },
    props: {
        'targets': Array,
    },
    data: function() {
        return {
            type: 'pfam',
            families: [],
            level: 0,
            name: '',
            similarity: '90',
            accession: '',
        }
    },
    methods: {
        changeType(type) {
            this.type = type;
            console.log(this.type);
            this.loadFamilies()
        },
        loadFamilies() {
            if (this.type == 'cdhit') {
                return;
            }
            const self = this;
            this.$axios.get(this.$api_base + '/api/families/' + this.type).then(function(response) {
                self.families = [[''].concat(response.data['families'])]
                if (self.type == 'pfam') {
                    self.loadChildFamily(2, '');
                }
            }).catch(function(e) {
                console.log(e);
            });
        },
        changeFamily(level, name) {
            this.level = level;
            this.name = name;
            if (this.level > 5) {
                return;
            }
            if (this.type == 'pfam' && this.level == 2) {
                return;
            }
            this.families.length = this.level;
            this.loadChildFamily(this.level + 1, this.name);
        },
        loadChildFamily(level, parent) {
            const self = this;
            console.log(this.type, level, parent);
            this.$axios.get(this.$api_base + '/api/families/' + this.type + '/' + level + '/' + parent).then(function(response) {
                self.families.push([''].concat(response.data['families']));
            }).catch(function(e) {
                console.log(e);
            });
        },
        addTargets() {
            const self = this;

            let level = this.level;
            let name = this.name;
            if (this.type == 'cdhit') {
                level = this.similarity;
                name = this.accession;
            }
            this.$axios.get(this.$api_base + '/api/targets/' + this.type + '/' + level + '/' + name).then(function(response) {
                let accessions = response.data['targets'];
                let newTargets = self.uniq(self.targets.concat(accessions));

                self.$emit('changeTargets', newTargets);
            }).catch(function(e) {
                console.log(e);
            });
        },
        clearTargets() {
            this.$emit('changeTargets', []);
        },
        uniq(array) {
            return Array.from(new Set(array));
        },
        deleteTarget(name) {
            let newTargets = this.targets.filter(n => n != name);
            this.$emit('changeTargets', newTargets);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.families {
    padding: 10px;
}

.targets {
    margin-top: 30px;
    min-height: 50px;
    max-height: 300px;
    overflow-y: scroll;
    width: 80%;
    margin-left: 10%;
    border: solid 1px;
}

.targets div {
    text-align: left;
    padding-top: 0px;
    padding-bottom:0px;
}

.label {
    font-size: 20px;
}

.left {
    text-align: left;
}

button {
    width: 120px;
}

</style>
